
import SiteSidebar from '~/layouts/partials/public/sidebar'

export default {
	components:{
		  SiteSidebar
	},
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@graph": [
	      {
	      	"@type": "Organization",
	      	"@id": `${process.env.BASE_URL}/#organization`,
	      	"name": `${this.$config.siteName}`,
	      	"url": process.env.BASE_URL,
	      	"email": "support@webtoolsmate.com",
	      	"logo":{
	      		"@type": "ImageObject",
	      		"@id": `${process.env.BASE_URL}/#logo`,
	      		"url": `${process.env.BASE_URL}/assets/images/webtoolsmate-logo.png`,
	      		"contentUrl": `${process.env.BASE_URL}/assets/images/webtoolsmate-logo.png`,
	      		"caption": `${this.$config.siteName}`,
	      		"inLanguage": "en-US",
	      		"width": "512",
	      		"height": "512"
	      	},
	      	"sameAs": this.$config.socialLinks
	      },
	      {
	      	"@type":"WebSite",
	      	"url":`${process.env.BASE_URL}`,
	      	"name":`${this.$config.siteName}`,
	      	"inLanguage":"en-US",
					"publisher":{
						"@id": `${process.env.BASE_URL}/#organization`
					},
					"potentialAction":{
						"@type":"SearchAction",
						"target": `${process.env.BASE_URL}/search/{search_term_string}`,
						"query-input":"required name=search_term_string"
					}
	      },
	      {
			    "@type": "CreativeWorkSeries",
			    "name": `${this.post.page_title} | ${this.$config.siteName}`,
			    "aggregateRating": {
			        "@type": "AggregateRating",
			        "ratingValue": "5",
			        "bestRating": "5",
			        "ratingCount": "12"
			    }
	      }
      ]
    };
  },
	head() {
		return {
			title: `${this.post.page_title} | ${this.$config.siteName}`,
			meta: [
				{ hid: 'title', name: 'title', content: `${this.post.page_title} | ${this.$config.siteName}` },
				{ hid: 'description', name: 'description', content: this.post.short_description },
				// Facebook meta settings
				{ hid: 'og:site_name', property: 'og:site_name', content: `${this.$config.siteName}` },
				{ hid: 'og:email', property: 'og:email', content: 'support@webtoolsmate.com' },
				{ hid: 'og:title', property: 'og:title', content: `${this.post.page_title} | ${this.$config.siteName}` },
				{ hid: 'og:description', property: 'og:description', content: this.post.short_description },
				{ hid: 'og:type', property: 'og:type', content: 'article' },
				{ hid: 'og:image', property: 'og:image', content: `${this.post.featured_image}` },
				{ hid: 'og:url', property: 'og:url', content: `${process.env.BASE_URL}${this.$route.path}` },
				{ hid: 'og:locale', property: 'og:locale', content: 'en_US' },
				// Twitter meta settings
				{ hid: 'twitter:site', name: 'twitter:description', content: '@webtoolsmate' },
				{ hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
				{ hid: 'twitter:url', name: 'twitter:url', content: `${process.env.BASE_URL}${this.$route.path}` },
				{ hid: 'twitter:creator', name: 'twitter:creator', content: 'webtoolsmate' },
				{ hid: 'twitter:title', name: 'twitter:title', content: `${this.post.page_title} | ${this.$config.siteName}` },
				{ hid: 'twitter:description', name: 'twitter:description', content: this.post.short_description },
				{ hid: 'twitter:image', name: 'twitter:image', content: `${this.post.featured_image}` },
			],
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: `https://webtoolsmate.com${this.$route.path}`
        }
      ]
		}
	},
	data() {
		return {
			post: []
		};
	},
	async asyncData({ $axios, params, error, redirect }) {
		try {

			const response = await $axios.$get(`/${params.slug}`);

			return { post: response.post, popular_tools: response.popular_tools, htmlSource: response.post.description };

		} catch (e) {
      if (e.response.status === 404) {
        error({ statusCode: 404 });
      } else if (e.response.status === 401) {
        redirect('/login');
      } else {
        error({ statusCode: 500 });
      }
		}
	}
};
